import { SindriClient } from "./client";

export default new SindriClient();

export type * from "./client";
export type { LogLevel } from "./logging";
